import {ActualAddress, Participants, Counterparties, Notifiers, ServiceOffice} from '@ifr/form-questionnaire/src/types/Elements'
export default [
    new ActualAddress(),
    new Participants(),
    new Counterparties(),
    new ServiceOffice(),
    new Notifiers()
]
